"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosProductTypeUpdateInputSchema = exports.APosProductTypeCreateInputSchema = exports.APosProductTypeSchema = exports.APosProductTypeStatusSchema = exports.APosVariantAttributeSchema = exports.APosWeightUnitSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosWeightUnitSchema = zod_1.z.enum(['kg', 'lb', 'g', 'oz']);
exports.APosVariantAttributeSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(50),
    required: zod_1.z.boolean().default(false),
    options: zod_1.z.array(zod_1.z.string()).optional(),
});
exports.APosProductTypeStatusSchema = zod_1.z.enum(['active', 'deleted']);
exports.APosProductTypeSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    typeId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(200).optional(),
    icon: zod_1.z.string().max(50).optional(),
    variantAttributes: zod_1.z.array(exports.APosVariantAttributeSchema).default([]),
    defaultTaxCategory: zod_1.z.string().optional(),
    trackInventory: zod_1.z.boolean().default(true),
    isWeighted: zod_1.z.boolean().default(false),
    weightUnit: exports.APosWeightUnitSchema.optional(),
    isSystem: zod_1.z.boolean().default(false),
    status: exports.APosProductTypeStatusSchema.default('active'),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosProductTypeCreateInputSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(200).optional(),
    icon: zod_1.z.string().max(50).optional(),
    variantAttributes: zod_1.z.array(exports.APosVariantAttributeSchema).optional(),
    defaultTaxCategory: zod_1.z.string().optional(),
    trackInventory: zod_1.z.boolean().optional(),
    isWeighted: zod_1.z.boolean().optional(),
    weightUnit: exports.APosWeightUnitSchema.optional(),
});
exports.APosProductTypeUpdateInputSchema = exports.APosProductTypeCreateInputSchema.partial().extend({
    status: exports.APosProductTypeStatusSchema.optional(),
});
//# sourceMappingURL=product-type.schema.js.map